module.exports = __webpack_public_path__ + "img/dso-icon.2663879a.svg";